import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { ProgramsModule } from '../programs/programs.module';

@NgModule({
  imports: [
    GCCoreModule,
    ProgramsModule
  ]
})
export class NominationsModule { }
